import React from 'react';
import { Shield, Heart, Clock, Award } from 'lucide-react';
import { motion } from 'framer-motion';
export function About() {
  return <div className="bg-white" data-id="element-178">
      {/* Page Header */}
      <div className="bg-brand-light py-20 lg:py-32" data-id="element-179">
        <div className="container mx-auto px-4 md:px-6 text-center" data-id="element-180">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-brand-blue mb-6 tracking-tight" data-id="element-181">
            About CareBridge
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed" data-id="element-182">
            Dedicated to providing safe, reliable, and compassionate
            non-emergency medical transportation for our community.
          </motion.p>
        </div>
      </div>

      {/* Mission Section */}
      <section className="py-20" data-id="element-183">
        <div className="container mx-auto px-4 md:px-6" data-id="element-184">
          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-185">
            <div data-id="element-186">
              <h2 className="text-3xl md:text-4xl font-extrabold text-brand-blue mb-6" data-id="element-187">
                Our Mission
              </h2>
              <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-188">
                <p data-id="element-189">
                  At CareBridge, we are on a mission to redefine the Inter
                  Facility Transfer industry, offering our valued customers a
                  comprehensive continuum of care.
                </p>
                <p data-id="element-190">
                  We understand that medical transportation is more than just
                  getting from point A to point B. It's about ensuring the
                  dignity, comfort, and safety of every patient entrusted to our
                  care.
                </p>
                <p data-id="element-191">
                  Beyond merely providing transportation, we believe in
                  elevating the non-emergency medical transportation experience
                  to something more profound—a seamless extension of the
                  healthcare system.
                </p>
              </div>
            </div>
            <div className="relative rounded-3xl overflow-hidden shadow-2xl aspect-[4/3]" data-id="element-192">
              <img src="https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&q=80&w=1200" alt="Medical professionals caring for a patient" className="w-full h-full object-cover" data-id="element-193" />
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-20 bg-gray-50" data-id="element-194">
        <div className="container mx-auto px-4 md:px-6" data-id="element-195">
          <div className="text-center mb-16" data-id="element-196">
            <h2 className="text-3xl md:text-4xl font-extrabold text-brand-blue mb-6" data-id="element-197">
              Our Core Values
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-198">
              These principles guide every decision we make and every
              interaction we have with our patients and partners.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-199">
            {[{
            icon: Heart,
            title: 'Compassion',
            desc: 'Treating every patient like family with empathy and respect.'
          }, {
            icon: Shield,
            title: 'Safety First',
            desc: 'Rigorous training and vehicle maintenance to ensure secure transport.'
          }, {
            icon: Clock,
            title: 'Reliability',
            desc: 'Punctual service you can count on for critical appointments.'
          }, {
            icon: Award,
            title: 'Excellence',
            desc: 'Continuously improving our standards of care and service.'
          }].map((value, i) => <div key={i} className="bg-white p-8 rounded-3xl shadow-sm border border-gray-100 text-center hover:shadow-xl transition-shadow" data-id="element-200">
                <div className="w-16 h-16 bg-brand-light rounded-full flex items-center justify-center text-brand-blue mx-auto mb-6" data-id="element-201">
                  <value.icon size={32} data-id="element-202" />
                </div>
                <h3 className="text-xl font-bold text-brand-blue mb-4" data-id="element-203">
                  {value.title}
                </h3>
                <p className="text-gray-600" data-id="element-204">{value.desc}</p>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}